import type { IFuturePowSetting } from "../types";

export const documentCreationLoadingDelay = import.meta.env.MODE === "cypress" ? 1 : 3500;

export const settingIds = {
  personalConditions: "personalConditions",
  economicConditions: "economicConditions",
  gps: "gps",
  gifts: "gifts",
  greaterGifts: "greaterGifts",
  accounting: "accounting",
  remuneration: "remuneration",
  remuneration_yearly: "remuneration_yearly",
  receiver_agreement_primary: "receiver_agreement_primary",
  receiver_agreement_subsidiary: "receiver_agreement_subsidiary",
  extend: "extend",
} as const;

export const settingCategories = {
  agents: "agents",
  personal: "personal",
  economic: "economic",
  general: "general",
} as const;

export const greaterGiftsOptions = {
  yes: "yes",
  yes_equal: "yes_equal",
  yes_other: "yes_other",
  yes_other_equal: "yes_other_equal",
  no: "no",
} as const;

export const extendOptions = {
  economic_personal: "economic_personal",
  economic: "economic",
  personal: "personal",
  custom: "custom",
} as const;

export const agentTypes = {
  primary: "primary",
  subsidiary: "subsidiary",
} as const;

export const agentAgreementOptions = {
  separate: "separate",
  united: "united",
} as const;

export const uiOnlySettingIds: readonly IFuturePowSetting["id"][] = [
  settingIds.personalConditions,
  settingIds.economicConditions,
];

export const recommendedSettings: IFuturePowSetting[] = [
  { id: settingIds.personalConditions, value: "yes", category: settingCategories.personal },
  { id: settingIds.gps, value: "yes", category: settingCategories.personal },
  { id: settingIds.economicConditions, value: "yes", category: settingCategories.economic },
  { id: settingIds.gifts, value: "yes", category: settingCategories.economic },
  { id: settingIds.greaterGifts, value: "no", category: settingCategories.economic },
  { id: settingIds.accounting, value: "no", category: settingCategories.economic },
  { id: settingIds.remuneration, value: "no", category: settingCategories.economic },
];
